/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBrands200ResponseInner
 */
export interface GetBrands200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetBrands200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrands200ResponseInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrands200ResponseInner
     */
    organizationId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrands200ResponseInner
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrands200ResponseInner
     */
    isMarketplace?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetBrands200ResponseInner
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof GetBrands200ResponseInner
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrands200ResponseInner
     */
    coverImageId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrands200ResponseInner
     */
    colorLogoImageId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrands200ResponseInner
     */
    faviconImageId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrands200ResponseInner
     */
    accentColor?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrands200ResponseInner
     */
    secondaryColor?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrands200ResponseInner
     */
    topbarColor?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBrands200ResponseInner
     */
    subBrands?: Array<string>;
}

/**
 * Check if a given object implements the GetBrands200ResponseInner interface.
 */
export function instanceOfGetBrands200ResponseInner(value: object): value is GetBrands200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetBrands200ResponseInnerFromJSON(json: any): GetBrands200ResponseInner {
    return GetBrands200ResponseInnerFromJSONTyped(json, false);
}

export function GetBrands200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBrands200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'isMarketplace': json['isMarketplace'] == null ? undefined : json['isMarketplace'],
        'position': json['position'] == null ? undefined : json['position'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'coverImageId': json['coverImageId'] == null ? undefined : json['coverImageId'],
        'colorLogoImageId': json['colorLogoImageId'] == null ? undefined : json['colorLogoImageId'],
        'faviconImageId': json['faviconImageId'] == null ? undefined : json['faviconImageId'],
        'accentColor': json['accentColor'] == null ? undefined : json['accentColor'],
        'secondaryColor': json['secondaryColor'] == null ? undefined : json['secondaryColor'],
        'topbarColor': json['topbarColor'] == null ? undefined : json['topbarColor'],
        'subBrands': json['subBrands'] == null ? undefined : json['subBrands'],
    };
}

export function GetBrands200ResponseInnerToJSON(json: any): GetBrands200ResponseInner {
    return GetBrands200ResponseInnerToJSONTyped(json, false);
}

export function GetBrands200ResponseInnerToJSONTyped(value?: GetBrands200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'organizationId': value['organizationId'],
        'deleted': value['deleted'],
        'isMarketplace': value['isMarketplace'],
        'position': value['position'],
        'imageId': value['imageId'],
        'coverImageId': value['coverImageId'],
        'colorLogoImageId': value['colorLogoImageId'],
        'faviconImageId': value['faviconImageId'],
        'accentColor': value['accentColor'],
        'secondaryColor': value['secondaryColor'],
        'topbarColor': value['topbarColor'],
        'subBrands': value['subBrands'],
    };
}

